import { Component, inject, input, output, ViewEncapsulation } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { DurationCommand } from '@src/suite/common/store/story/models/story.models';
import { ProductionCommandFieldsLabelKeys, ProductionFieldName } from '@src/suite/common/utils/ml-2-html-utils';

import { DurationSecondsInputFieldComponent } from '../../../controls/duration-seconds-input-field/duration-seconds-input-field';

@Component({
    selector: 'st-duration-command-dialog',
    imports: [DurationSecondsInputFieldComponent, LetDirective],
    templateUrl: './duration-command-dialog.html',
    styleUrl: './duration-command-dialog.scss',
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-duration-command-dialog' },
})
export class DurationCommandDialogComponent {
    // injectables
    store = inject(Store);

    // store signals
    languageSettings = this.store.selectSignal(selectI18N);

    // inputs
    public readonly command = input<DurationCommand>();

    // outputs
    public readonly commandChange = output<DurationCommand>();
    public readonly enterEmitter = output<DurationCommand>();

    // constants
    ProductionFieldName = ProductionFieldName;
    ProductionCommandFieldsLabelKeys = ProductionCommandFieldsLabelKeys;

    public onCommandsObjectChange(event: any, fieldName: ProductionFieldName) {
        if (this.command()) {
            this.command()[fieldName] = event;
            this.commandChange.emit(this.command());
        }
    }

    public onEnterSaveCommand(event: any) {
        this.onCommandsObjectChange(event, ProductionFieldName.DURATION);
        this.enterEmitter.emit(this.command());
    }
}
